<app-multimarket-view
        [title]="'MULTIMARKET.LINKS_TO_HELP_DESK'"
        [marketField]="'helpDesk'"
        [linkType]="'mail'"
></app-multimarket-view>
